export enum LogSource {
  Console,

  // Services
  ActivityLogService,
  AppService,
  AppStateService,
  ColorService,
  ComponentManagerService,
  FileService,
  IndexedDbService,
  localStorageService,
  PleaseWaitService,
  ServerService,
  SignalRService,
  UpdaterService,
  AttachmentService,
  AuthService,
  TenantService,
  CategoryService,
  CommunicationService,
  MailTrackingService,
  CustomerService,
  CommentService,
  PostService,
  EmailingService,
  FlagService,
  JobService,
  LoggingService,
  HarService,
  PaymentService,
  PaymentLinkService,
  PermissionService,
  QuoteService,
  TagReplacerService,
  SnippetService,
  TabbingService,
  TooltipService,
  UserService,
  ChatService,
  PlatformService,
  NavigationService,
  AuditService,
  AccountSettingsService,

  // Directives
  ProblemDetailsDirective,

  // Guards
  AuthGuard,
  LoginGuard,
  TenantGuard,
  LoggedInGuard,
  AttachmentGuard,
  CategoryGuard,
  CustomerGuard,
  JobGuard,
  CommunicationGuard,
  PaymentLinkGuard,
  PermissionGuard,
  QuoteCreatorGuard,
  SnippetGuard,

  // Common Components
  GenericBuilderComponent,
  GenericDisplayComponent,
  GenericEditorComponent,
  GenericViewerComponent,
  PageComponent,
  PageLayout2Component,
  PageLayout3Component,
  PageLayout4Component,

  AppointmentNotification,
  ActionItemsComponent,
  ButtonComponent,
  DateIntervalFieldComponent,
  FieldLabelComponent,
  FieldWrapperComponent,
  BooleanFieldComponent,
  CarrierSingleSelectFieldComponent,
  CarrierRedirectComponent,
  CustomerFieldComponent,
  SnippetFieldComponent,
  DateFieldComponent,
  DropdownFieldComponent,
  FlagMultiSelectFieldComponent,
  FlagSingleSelectFieldComponent,
  GenericFieldComponent,
  JobFieldComponent,
  MultiComlumnFieldComponent,
  MultiColumnSeparatorComponent,
  MultiSelectFieldComponent,
  NumberFieldComponent,
  PostFieldComponent,
  SingleSelectFieldComponent,
  TextFieldComponent,
  TimeFieldComponent,
  WorkerFieldComponent,
  FlexRowComponent,
  FlexSeparatorComponent,
  ImageHandlerComponent,
  LabelComponent,
  QuickFlagWidgetComponent,
  SquareButtonComponent,
  AutocompleteAdvancedFieldComponent,
  CurrencyFieldComponent,
  CurrencyInputFieldComponent,
  VirtualListComponent,

  // Components
  ActivityLogComponent,
  AccordionListComponent,
  CurrentUserMenuViewComponent,
  DoubleCheckPopupComponent,
  HtmlEditorComponent,
  HtmlViewerComponent,
  PleaseWaitComponent,
  PayPalButtonComponent,
  QuoteOperationsListViewComponent,
  RadioEnumSelectorComponent,
  RadioToCheckboxComponent,
  SideDialComponent,
  SideNavComponent,
  TabViewComponent,
  TitleBarComponent,
  UpdaterComponent,
  QueryControl,

  // Pages
  AttachmentsPage,
  AttachmentBuilder,
  AttachmentDiff,
  AttachmentEditor,
  AttachmentViewer,
  AttachmentListView,
  RemoteFileViewer,

  LoginPage,
  TenantSelectionPage,

  CategoriesPage,
  CategoryListView,
  CategoryBuilder,
  CategoryDiff,
  CategoryEditor,
  CategoryViewer,
  CategoryAssigner,

  CommunicationsPage,
  CommunicationsTab,
  CommunicationsLogsTab,
  CommunicationBuilder,
  CommunicationDiff,
  CommunicationDisplay,
  CommunicationEditor,
  CommunicationFilter,
  CommunicationList,
  CommunicationListEntry,
  CommunicationViewer,

  CustomersPage,
  CustomersTabs,
  CustomerBuilder,
  CustomerDeleteConflictPopup,
  CustomerDiff,
  CustomerDisplay,
  CustomerEditor,
  CustomerListEntry,
  CustomerTooltip,
  CustomerViewer,
  CustomerListView,

  DocsPage,
  DocsBuilder,
  DocsComment,
  DocsCommentBuilder,
  DocsCommentEditor,
  DocsCommentSection,
  DocsPostDisplay,
  DocsPostEditor,
  DocsPostViewer,
  DocsSideNav,

  FlagEditor,
  FlagViewer,
  PopupFlagEditor,
  FlagEditorDirective,

  HomePage,
  HomeJobList,

  JobsPage,
  JobTree,
  TreeJobEntry,
  AggregatedJobList,
  JobBuilder,
  JobDiff,
  JobDisplay,
  JobEditor,
  JobList,
  JobListEntry,
  JobViewer,
  TreeJobListEntry,

  PermissionsPage,
  GroupBuilder,
  GroupEditor,
  GroupListView,
  PermissionEditor,

  SnippetPage,
  SnippetBuilder,
  SnippetDiff,
  SnippetDisplay,
  SnippetEditor,
  SnippetViewer,
  SnippetListView,

  TooltipRenderer,
  TooltipContent,

  AccountBuilder,
  AccountEditor,
  AccountListView,
  UserListview,
  AuditsListView,

  MainChat,
  ChatRoomList,
  ChatRoom,

  AppointmentsPage,
  AppointmentsViewer,
  AppointmentsListView,
  AppointmentsDisplay,
  AppointmentsEditor,
  AppointmentsBuilder,
  AppointmentsCalendar,
  AppointmentsTab,
  AppointmentService
}
